import { DetailedLoadStatus } from "../../../../../../../common/utils/async-status";
import { ConfidenceLevel } from "../../../../../../../services/overleaf/utils";
import { NormalizedData } from "../types";

export const CREATE_CARD_PREFIX = "overleaf/card/create";
export const UPDATE_CARD_PREFIX = "overleaf/card/update";
export const DELETE_CARD_PREFIX = "overleaf/card/delete";

export type FlashcardData = overleaf.FullCard & {
  confidenceLevel: ConfidenceLevel;
};

export interface FlashcardState {
  flashcardData: NormalizedData<FlashcardData>;
  loadStatus: DetailedLoadStatus;
  error?: { name: string; code: string } | null;
}
